import { render, staticRenderFns } from "./ManageChannelViewingSlots.vue?vue&type=template&id=dcab7d02&scoped=true&"
import script from "./ManageChannelViewingSlots.vue?vue&type=script&lang=js&"
export * from "./ManageChannelViewingSlots.vue?vue&type=script&lang=js&"
import style0 from "./ManageChannelViewingSlots.vue?vue&type=style&index=0&id=dcab7d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcab7d02",
  null
  
)

export default component.exports